module.exports = __webpack_public_path__ + "img/vertical_6_3_8023.f99e5aff.png";